import { defineMessages } from "react-intl";

export const messages = defineMessages({
    // File entity
    fileEntitySingular: {
        id: "files.file.entity_singular",
        defaultMessage: "File",
    },
    fileEntityPlural: {
        id: "files.file.entity_plural",
        defaultMessage: "Files",
    },
    fileEntityDefiniteArticle: {
        id: "files.file.entity_definite_article",
        defaultMessage: "the file",
    },
    fileEntityDemonstrative: {
        id: "files.file.entity_demonstrative",
        defaultMessage: "this file",
    },
    fileEntityIndefiniteArticle: {
        id: "files.file.entity_indefinite_article",
        defaultMessage: "a file",
    },
});
